export const TASK_UNDO_TARGET_TYPE = {
    CHECKLIST_ITEM: 'checklist-item',
    TASK: 'task',
};

export function resolveTaskUndoTarget(item) {
    const taskId = item?.taskId ?? item?.rawTask?.id ?? null;
    if (!taskId) return null;

    const itemId = item?.itemId ?? null;
    if (itemId && !item?.isStandaloneTask) {
        return {
            type: TASK_UNDO_TARGET_TYPE.CHECKLIST_ITEM,
            taskId,
            itemId,
        };
    }

    return {
        type: TASK_UNDO_TARGET_TYPE.TASK,
        taskId,
    };
}

export function buildReopenedTaskCard(item, target = null) {
    const undoTarget = target || resolveTaskUndoTarget(item);
    if (!item || !undoTarget) return item;

    return {
        ...item,
        taskId: undoTarget.taskId,
        itemId: item?.itemId ?? null,
        completion_state: 'OPEN',
        completed_at: null,
        is_completed: false,
    };
}
